import { render, staticRenderFns } from "./Hchospitalizacion.vue?vue&type=template&id=00fe56d6"
import script from "./Hchospitalizacion.vue?vue&type=script&lang=js"
export * from "./Hchospitalizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports